
    import Component from "vue-class-component";
    import Vue from "vue";
    import {Prop} from "vue-property-decorator";
    import {
        ApplicationActions,
        ApplicationViewModel,
        PositionApiModel,
        PositionsCollectionViewModel,
        PositionsRequirementViewModel,
        RequirementFulfillmentViewModel,
        RequirementsClient
    } from "@/api-client";
    import RequirementProcessingDecision from "@/features/applications/components/RequirementProcessingDecision.vue";
    import {ls} from "@/CultureService";

    @Component({
        components: {RequirementProcessingDecision}
    })
    export default class PositionsRequirement extends Vue {
        public static headingDescription = ls.Applications_Requirements_Positions_Heading_ChooseEndorsementPositions;

        @Prop({required: true})
        application!: ApplicationViewModel;
        @Prop({required: true})
        requirementFulfillment!: RequirementFulfillmentViewModel;
        @Prop({required: true})
        requirement!: PositionsRequirementViewModel;
        @Prop({required: true})
        actions!: ApplicationActions;
        @Prop({required: true})
        requirementValue!: PositionsCollectionViewModel | null;

        choosable: PositionApiModel[] | null = null;
        chosen: PositionApiModel[] | null = null;
        checkboxSelectedIds: string[] = [];

        get checkboxPositions(): PositionApiModel[] {
            if (this.choosable)
                return this.choosable;

            if (this.chosen)
                return this.chosen;

            return [];
        }

        async created() {
            if (this.actions.canFillRequirements) {
                this.choosable = await new RequirementsClient().choosable(this.application.id, this.requirement.id);
            }

            if (this.requirementValue) {
                this.requirementValue.positionIds.forEach((id: string) => this.checkboxSelectedIds.push(id))
                this.chosen = await new RequirementsClient().chosenPositions(this.application.id, this.requirement.id);
            }
        }

        toggle(position: PositionApiModel) {
            let newChosen: PositionApiModel[] = [];

            if (this.chosen)
                this.chosen.forEach(x => {
                    newChosen.push(new PositionApiModel(x))
                });

            const isToggledValueAlreadyChosen = newChosen.some(x => x.id === position.id);
            if (isToggledValueAlreadyChosen)
                newChosen = newChosen.filter(x => x.id !== position.id); // Means that the chosen value was un-chosen.
            else
                newChosen.push(position)

            const isAnythingChosen = !!newChosen.length;  
            if (isAnythingChosen)
                new RequirementsClient().choosePositions(newChosen.map(x => x.id), this.application.id, this.requirement.id).then(
                    () => this.$emit("application-changed"),
                    error => this.$emit("error-happened", error));
            else // Remove if nothing chosen.
                new RequirementsClient().removeChosenValue(this.application.id, this.requirement.id).then(
                    () => this.$emit("application-changed"),
                    error => this.$emit("error-happened", error));
        }
    }
